import { PublicSurvey, SubmitSurveyResponse } from "@models";
import i18n from "../i18n";
import { surveyService } from "@services";
import { message } from "@messages";
import { makeAutoObservable, runInAction } from "mobx";

export default class SurveyStore {
  survey: PublicSurvey | null = null;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getPending = async (tenantId: number, customerId: number) => {
    try {
      const response = await surveyService.getPending(tenantId, customerId);
      runInAction(() => {
        this.survey = response;
      });
    } catch {
      // Silently ignore — no survey available
      runInAction(() => {
        this.survey = null;
      });
    }
  };

  submit = async (request: SubmitSurveyResponse) => {
    this.setLoading(true);
    try {
      await surveyService.submit(request);
      runInAction(() => {
        this.survey = null;
      });
      this.setLoading(false);
      message.success(i18n.t("ThankYouForFeedback"));
    } catch (error) {
      console.log(error);
      this.setLoading(false);
    }
  };

  reset = () => {
    runInAction(() => {
      this.survey = null;
    });
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };
}
